<template>
  <div>
      <v-toolbar
      color="primary"
      v-resize="handleShrinkTitle"
      >
      <img src="@/assets/logo.png" style="height: 40px" >
      <v-toolbar-title v-if="bigScreen"  class="white--text" >
      <h1 style="float:left; padding-right: 10px" > ELEMENT Air </h1>
      <h1 style="color:orange; float:right;"> BETA</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="bigScreen"  class="white--text"  ><h1>Welcome {{this.$store.state.app.mandate.name}}</h1></v-toolbar-title>
      <v-spacer></v-spacer>


      <v-text-field  v-model="search" class="ml-3" solo clearable hide-details label="Search Projects" ></v-text-field>

    </v-toolbar>

    <v-data-table
    :pagination.sync="pagination" :items="projects" class="items" :headers="project_headers" :search="search" :rows-per-page-items="rowsPerPageItems">
      <template slot="items" slot-scope="props">
        <tr>
          <td @click= "doOnProjectClick(props.item)" v-on:dblclick= "toMap(props.item)" class= "tableFontSize" v-bind:class= "{'selected-row': props.item.id == projectSelectedId}">
            {{ props.item.name | trunc }}
          </td>
          <td @click= "doOnProjectClick(props.item)" v-on:dblclick= "toMap(props.item)" class= "tableFontSize"  v-bind:class="{'selected-row': props.item.id == projectSelectedId}">
            {{ props.item.locations.length }}
          </td>
          <td @click= "doOnProjectClick(props.item)" v-on:dblclick= "toMap(props.item)" class= "tableFontSize"  v-bind:class="{'selected-row': props.item.id == projectSelectedId}">
            {{ props.item.owner_name | trunc}}
          </td>
          <td v-if="!smallestScreen" @click= "doOnProjectClick(props.item)" v-on:dblclick= "toMap(props.item)" class= "tableFontSize"  v-bind:class="{'selected-row': props.item.id == projectSelectedId}">
            {{ calcDateFromTimestamp(props.item.locations)}} by {{props.item.last_updater | trunc}}
          </td>
          <td v-if="smallestScreen" @click= "doOnProjectClick(props.item)" v-on:dblclick= "toMap(props.item)" class= "tableFontSize"  v-bind:class="{'selected-row': props.item.id == projectSelectedId}">
            {{ calcDateFromTimestamp(props.item.locations)}}
          </td>
          <td  @click= "doOnProjectClick(props.item)" class= "tableFontSize"  v-bind:class="{'selected-row': props.item.id == projectSelectedId}">
           {{props.item.text | trunc}}
          </td>
    </tr>
  </template>
  <v-alert slot="no-results" :value="true" color="warning" icon="warning" transition="fade-transition">
    Your search for "{{ search }}" found no results.
  </v-alert>
</v-data-table>
</v-card>

<v-dialog lazy v-model="deleteConfirm" :max-width="300">
  <v-card>
    <v-card-text color="#fafafa">
      Do you really want to delete this Project?
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" flat @click="deleteProjectFromDB(editingProject), deleteConfirm = false ">Delete</v-btn>
      <v-btn color="black" flat @click="deleteConfirm = false">Cancel</v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>

<v-footer absolute height="auto">
  <v-card width=100% >
    <v-card color="#fafafa">
        <v-btn :disabled ="projectSelectedId!=null"color="primary"   @click.prevent="addProject" class="menuButton">
          <v-layout justify-space-around>
          <v-icon   >plus_one</v-icon>
          <div v-if="!smallestScreen">New Project</div>
          </v-layout>
        </v-btn>

        <v-btn :disabled ="projectSelectedId==null" color="orange darken-2 dark"   @click.prevent="openProjectEditor(editingProject)"class="menuButton">
          <v-layout justify-space-around>
            <v-icon  >build</v-icon>
            <div v-if="!smallestScreen">Edit Project</div>
          </v-layout>
        </v-btn>

        <v-btn :disabled ="projectSelectedId==null" color="red"   @click.prevent= "deleteConfirm=true"class="menuButton">
          <v-layout justify-space-around>
          <v-icon  >remove_circle</v-icon>
          <div v-if="!smallestScreen">Delete Project</div>
          </v-layout>
        </v-btn>
        <v-btn :disabled ="projectSelectedId==null" color="success"  :to="{ name: 'map', params: { project: editingProject, host: host } }"class="menuButton">
          <v-layout justify-space-around>
          <div v-if="!smallestScreen">To map</div>
          <v-icon  >arrow_forward</v-icon>
          </v-layout>
        </v-btn>
  </v-card>
  <v-card>
    <v-alert class="sideAlert" :value="successFlag" type="success" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
    <v-alert class="sideAlert" :value="failFlag" type="error" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
    <v-alert class="sideAlert" :value="infoFlag" type="info" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
    <v-alert class="sideAlert" :value="warningFlag" type="warning" transition="fade-transition" :dismissible="true" >{{currentAlertMessage}}</v-alert>
</v-card>

<v-card color="primary">
  <v-btn v-on:click="backToElement()" depressed color="primary">
    <v-icon>arrow_back</v-icon>
    Back to ELEMENT
  </v-btn>
</v-card>
</v-card>
</v-footer>




<v-dialog v-model="projectEditorOpen" lazy :max-width="320" :persistent="true">
  <v-card v-if="projectEditorOpen">
    <v-card-text>
      <project-form v-model="editingProject" :newProjectFlag= "newProjectFlag"   :projects= "projects" v-on:valid="validProject=$event"></project-form>
    </v-card-text>
    <v-card-actions>
      <div v-if ="newProjectFlag">
        <v-btn :disabled= "!validProject" color="primary" flat @click= "projectEditorOpen = false, newProjectToDB(editingProject),setNewProjFalse(), newProjectFlag=false">Save</v-btn>
        <v-btn flat color="secondary" @click="projectEditorOpen = false, deleteLastProject(),setNewProjFalse(), newProjectFlag=false">Cancel</v-btn>
      </div>
      <div v-else-if="!newProjectFlag">
        <v-btn :disabled= "!validProject" color="primary" flat @click="projectEditorOpen = false, putProjectToDB(editingProject)">Save</v-btn>
        <v-btn flat color="secondary" @click="projectEditorOpen = false, revertItem()">Cancel</v-btn>
      </div>
      <div>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>


</div>
</template>

<script>
import axios from "axios"



export default {
  components: {
    projectForm: require("./ProjectForm").default
  },
  data(){
    return{
      search: '',
      projectSelectedId: null,
      name: "Welcome",
      pagination: {},
      projects: [],
      locations: [],
      projectEditorOpen: false,
      editingProject: null,
      newProjectFlag: false,
      deleteConfirm: false,
      alertTimeout: 3000,
      currentAlertMessage: "",
      successFlag: false,
      failFlag: false,
      infoFlag: false,
      warningFlag: false,
      validProject: false,
      bigScreen: true,
      smallestScreen: false,
      mandate_id:"",
      tempItem: {},
      /*Enable for Prod*/
      host:"",
      /*Enable for Dev*/
      //host:"http://localhost:4000",
      apiUrl: "",
      rowsPerPageItems: [-1],
      currentUserName: "",
      pagination: {
        rowsPerPage: null
},

    }
  },
  filters: {
  trunc: function (value) {
    if(typeof(value)!="undefined" && value!=null){
    if (value.length>20) return value.slice(0,19) + "..."
    else {
      return value
    }
  }
}
},

  methods: {

    toMap(item){
      this.doOnProjectClick(item)
      this.$router.push({
      name: 'map',
      params: { project: item, host: this.host }
    })
    },
    revertItem(){
      this.editingProject.name = this.tempItem.name
      this.editingProject.text = this.tempItem.text
    },

    getLastTimeStamp(locations){

      return new Date(Math.max.apply(null, locations.map(function(e) {
        return new Date(e.updated_at);
      })));

      },

    calcDateFromTimestamp(locations){
      let currentDate = this.getLastTimeStamp(locations)
      if(currentDate.toLocaleString()== "Invalid Date"){
        return ""
      }
      else {
            currentDate.setHours(-currentDate.getTimezoneOffset()/60+currentDate.getHours())
            return currentDate.toLocaleString()
      }
    },


    backToElement(){
      window.localStorage.clear()
      this.fireAlert("info", "Successfully logged out!")
      let self=this
      setTimeout(function(){
        window.location = self.$store.state.app.back_url
      },
      2000)
    },

    handleShrinkTitle(){
      this.pagination.rowsPerPage = parseInt( (window.innerHeight-250)/62)
      if(window.innerWidth>1000){
        this.bigScreen=true
        this.smallestScreen = false
        //this.pagination.rowsPerPage = 10
      }
      else {
        this.bigScreen =false
        this.smallestScreen = false

        //this.pagination.rowsPerPage = 10
        if(window.innerWidth<500){
          this.smallestScreen = true

        //  this.pagination.rowsPerPage = 5
        }
      }
    },
    setNewProjFalse(){
      let self=this
      setTimeout(function(){
        self.newProjectFlag = false;
      },
      200)
    },


    fireAlert(type, message){

      this.currentAlertMessage = message
      this.successFlag = false
      this.failFlag = false
      this.infoFlag = false
      this.successFlag = false

      switch(type){
        case "success":
        this.successFlag = true
        this.setAlertTimeout()
        break;
        case "fail":
        this.failFlag = true
        this.setAlertTimeout()
        break;
        case "info":
        this.infoFlag = true
        this.setAlertTimeout()
        break;
        case "success":
        this.successFlag = true
        this.setAlertTimeout()
        break;


      }
    },
    setAlertTimeout(){
      let self=this
      setTimeout(function(){
        self.successFlag = false;
        self.failFlag = false;
        self.infoFlag = false;
        self.warningFlag = false;
      },
      self.alertTimeout);
    },


    addProject(){
      this.newProjectFlag = true
      let newItem = {
        name: "",
        owner_name: this.currentUserName,
        last_updater: this.currentUserName,
        locations:[]
      }
      this.projects.push(newItem)
      this.editingProject= newItem
      this.openProjectEditor(newItem)

    },
    deleteLastProject(){
      this.projects.pop()

    },

    newProjectToDB(project){
      console.log('Try saving Project')
      var config = {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob'
      };
      let newProject = {project: project}
      axios.post(this.apiUrl, newProject, config)
      .then((response) => {
        console.log('saved successfully')
        this.fireAlert("success", "Project "+project.name+" successfully saved into Database")
        this.fetchProjects()
      }
    )
    .catch((err) => {
      this.projects.pop()
      this.fireAlert("fail", "Project not created")
    })
  },
  putProjectToDB(project){
    console.log('Try editing Project')
    var config = {
      headers: { 'Content-Type': 'application/json' },
      responseType: 'blob'
    };
    project.last_updater= this.currentUserName
    let id = project.id
    let editedProject = {project: project}
    axios.put(this.apiUrl.concat(id), editedProject , config)
    .then((response) => {
      console.log('edited successfully')
      this.fireAlert("success", "Project "+project.name+" successfully updated")
      this.fetchProjects()
    }
  )
  .catch((err) => {
    this.fireAlert("fail", "Project not updated")
  })
},

deleteProjectFromDB(project){
  var id = project.id
  var config = {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob'
  };
  axios.delete(this.apiUrl.concat(id), config)
  .then((response) => {
    console.log('deleted successfully')
    this.fireAlert("success", "Project "+project.name+" successfully deleted")
    this.fetchProjects()
    this.projectSelectedId = null
  }
)
.catch((err) => {
  this.fireAlert("fail", "Project not deleted")
})
},

openProjectEditor(project) {
  this.projectEditorOpen = true
  this.editingProject= project
  Object.assign(this.tempItem, project)
},

fetchProjects(){

  let url=this.apiUrl + "mandate"
  axios.get(url)
  .then(
    res => {
      this.projects = res.data.project
    }
  )
  .catch(err => console.log(err))


},

doOnProjectClick(project){

  if(this.projectSelectedId == project.id){
    this.projectSelectedId = null
  }
  else{
    this.projectSelectedId = project.id
    this.editingProject = project
  }
},
calculateRows() {
  let sidebar = this.$refs.sidebar
  let toolbar = this.$refs.sidebarToolbar.$el
  let space = sidebar.clientHeight - toolbar.clientHeight

  space -= 57 // top bar
  space -= 59 // bottom bar

  return Math.floor(space / 48);
}
},
created(){

this.apiUrl = this.host +"/api/project/"
},



mounted(){
  // Order important: fetchProjects will trigger the JWT authorization and after that, the store is filled
  this.fetchProjects()
  this.mandate_id = this.$store.state.app.mandate.id
  this.currentUserName = this.$store.state.app.user.name



},

computed: {
  project_headers() {
    return [
      {text: "Project name", value: "name", align: "left"},
      {text: "Locations", value: "locations.length", align: "left"},
      {text: "Owner Name", value: "owner_name", align: "left"},
      {text: "Last update", value: "", align: "left", sortable: false},
      {text: "Note", value: "text", align: "left"}
    ]
  },
  color() {
    switch (this.bottomNav) {
      case 0: return 'blue-grey'
      case 1: return 'teal'
      case 2: return 'brown'
      case 3: return 'indigo'
    }
  }
}

}
</script>

<style scoped>

.selected-row {
  background-color: #4CAF50;
}
.tableFontSize{
  font-size: 16pt;
}

.fade-transition-enter-active, .fade-transition-leave-active {
  transition: opacity 1s;
}
.fade-transition-enter, .fade-transition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fs {
  width: 100%;
  height: 100%;
}
.menuButton {
  min-width: 170px;
}
@media (max-width: 420px) {
  .menuButton {
    min-width: 20px;
  }
}

.secondaryColor{
  background-color: #424242
}
.img{
  position: relative;
  top: 200px

}
.sideAlert{
  z-index: +1;
  position: fixed;
  bottom: 60px;
  right: 40px;
  height: 59px;
}



</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue